import { useOffering } from '@services/offering';
import { useSearchQuoteItems } from '@services/quoteItem';
import { useSearchQuoteForms } from '@services/quoteForm';
import { useQuote } from '@services/quotes';
import { useStore } from '@store/GlobalStore';
import { StructuredQuote } from '@store/Quote/Quote.types';
import { useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';
import { useGetCustomer } from '@services/customer';

import { useQuoteStore } from '@store/Quote/QuoteStore';

export function useStructuredQuote(quoteId: string): {
  structuredQuote: StructuredQuote | undefined;
} {
  const { quote } = useQuote(quoteId);
  const { customer } = useGetCustomer(quote?.customer.id || '');
  const { offering } = useOffering(quote?.offering?.id);
  const { quoteItems: quoteItemSearch } = useSearchQuoteItems({ quoteId: quote?.id });
  const { quoteForms } = useSearchQuoteForms({ quoteId: quote?.id });

  const [isInternalUser] = useStore((state) => [state.userAuth.isInternalUser], shallow);

  const [structuredQuote, updateQuoteDetails, setCustomerBusinessAddress] = useQuoteStore((state) => [
    state.structuredQuote,
    state.updateQuoteDetails,
    state.setCustomerBusinessAddress,
  ]);

  const [out, setOut] = useState<{
    structuredQuote: StructuredQuote | undefined;
  }>({
    structuredQuote,
  });

  useEffect(() => {
    if (quote && offering && quoteItemSearch) {
      updateQuoteDetails(quoteId, quote, offering, quoteItemSearch, quoteForms, isInternalUser);
    }
  }, [quoteId, quote, offering, quoteItemSearch, quoteForms, isInternalUser, updateQuoteDetails]);

  useEffect(() => {
    if (customer) {
      setCustomerBusinessAddress(customer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer]);

  useEffect(() => {
    setOut({
      structuredQuote,
    });
  }, [structuredQuote]);

  return {
    ...out,
  };
}
